<template>
  <component :is="currentComponent"></component>
</template>

<script>
import EarLobeRepairContentEn from './EarLobeRepairContent/EarLobeRepairContentEn.vue';
import EarLobeRepairContentPtBR from './EarLobeRepairContent/EarLobeRepairContentPtBR.vue';
import EarLobeRepairContentEs from './EarLobeRepairContent/EarLobeRepairContentEs.vue';
import { LANGUAGES } from '@/common/constants';

export default {
  props: {
    language: {
      type: String,
      default: LANGUAGES.EN
    }
  },
  computed: {
    currentComponent() {
      if (this.language === LANGUAGES.PT_BR) {
        return EarLobeRepairContentPtBR;
      }
      if (this.language === LANGUAGES.ES) {
        return EarLobeRepairContentEs;
      }
      return EarLobeRepairContentEn;
    }
  }
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
